<template>
  <ion-page>
    <ion-content class="white">
      <ion-header style="font-weight: bold" class="ion-margin-bottom ion-margin-top ion-text-center">会員登録（ご本人確認）</ion-header>
      <MailSendComponent title="メールアドレスの仮登録" v-on:form-submit="submitForm" />
    </ion-content>
    <ion-loading trigger="open-loading" :duration="3000" message="処理中..."></ion-loading>
  </ion-page>
</template>

<script setup lang="ts">
import {
  IonPage,
  IonHeader,
  IonContent,
  IonLoading,
  loadingController,
  LoadingOptions,
} from "@ionic/vue";

import MailSendComponent from "../../components/MailSend.vue";
import request from '../../utils/Request'
import { Device } from '@capacitor/device';
import { useRouter } from 'vue-router';
import StorageService from '../../utils/StorageService'
import {datadogLogs} from "@datadog/browser-logs";

const router = useRouter()

async function submitForm (form: any) {
  const deviceInfo = await Device.getInfo()

  const loading = await createLoading('送信処理中...')
  await loading.present()
  await request.post('/register', {
    email: form.formRegisterMail.values.email,
    app_id: import.meta.env.VITE_APP_ID,
    device_uuid: await StorageService.get('deviceUuid'),
    osVersion: deviceInfo.osVersion,
    os: deviceInfo.operatingSystem
  }).then(async (res) => {
    if (res.status) {
      router.push({name: 'CodeVerifyOfRegistration', query: {email: form.formRegisterMail.values.email}})
      const loading = await createLoading('メールを送信しました', 2000,null)
      loading.present()
    }
  }).catch((err) => {
    if (!err.response) {
      datadogLogs.logger.error(err);
    }
    else if (err.response.status == 422) {
      form.formRegisterMail.setErrors(err.response.data.errors);
      return;
    }
    form.formRegisterMail.setErrors({email: ['エラーが発生しました']})
  }).finally(() => {
    loading.dismiss()
  })
}

async function createLoading(msg: string, duration?: number, spinner: LoadingOptions["spinner"] = "crescent") {
  return await loadingController.create({
      message: msg,
      duration: duration,
      spinner: spinner,
    })
}
</script>

<style scoped></style>
